import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertStatistics = ({ alerts }) => {
  const criticalCount = alerts?.filter(a => a?.severity === 'critical')?.length || 0;
  const highCount = alerts?.filter(a => a?.severity === 'high')?.length || 0;
  const unassignedCount = alerts?.filter(a => !a?.assignedTo)?.length || 0;
  const avgEscalationTime = alerts?.length > 0
    ? Math.round(alerts?.reduce((sum, a) => sum + a?.escalationTimer, 0) / alerts?.length)
    : 0;

  const stats = [
    {
      label: 'Critical Alerts',
      value: criticalCount,
      icon: 'AlertCircle',
      color: 'error',
      bgColor: 'bg-error/10',
      textColor: 'text-error',
      borderColor: 'border-error/20'
    },
    {
      label: 'High Priority',
      value: highCount,
      icon: 'AlertTriangle',
      color: 'warning',
      bgColor: 'bg-warning/10',
      textColor: 'text-warning',
      borderColor: 'border-warning/20'
    },
    {
      label: 'Unassigned',
      value: unassignedCount,
      icon: 'UserX',
      color: 'primary',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary',
      borderColor: 'border-primary/20'
    },
    {
      label: 'Avg Escalation Time',
      value: `${avgEscalationTime}m`,
      icon: 'Clock',
      color: 'success',
      bgColor: 'bg-success/10',
      textColor: 'text-success',
      borderColor: 'border-success/20'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`card ${stat?.bgColor} ${stat?.borderColor} border`}
        >
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.textColor} />
            </div>
            <div>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
              <p className="text-sm text-muted-foreground">{stat?.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertStatistics;